(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/result-utils/assets/javascripts/use-result-row.js') >= 0) return;  svs.modules.push('/components/racing/result-utils/assets/javascripts/use-result-row.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useMemo = _React.useMemo,
  useState = _React.useState,
  useEffect = _React.useEffect;
const _svs$racing$common$co = svs.racing.common.constants,
  gameTypes = _svs$racing$common$co.gameTypes,
  resultPlaceholders = _svs$racing$common$co.resultPlaceholders;
const _svs$components$racin = svs.components.racing.resultUtils,
  wagerToRows = _svs$components$racin.wagerToRows,
  myGamingUtil = _svs$components$racin.myGamingUtil,
  gameTypeWindivs = _svs$components$racin.gameTypeWindivs;
const _svs$components$racin2 = svs.components.racing.resultUtils.valuation,
  getRowValues = _svs$components$racin2.getRowValues,
  getRowWindiv = _svs$components$racin2.getRowWindiv,
  getRowValuesWithIrrelevant = _svs$components$racin2.getRowValuesWithIrrelevant,
  getNumTotalCorrectIrrelevant = _svs$components$racin2.getNumTotalCorrectIrrelevant;
const getCancelledParticipants = svs.racing.common.util.getCancelledParticipants;
const buildUniqueRankRows = svs.racing.build_unique_rank_row.buildUniqueRankRows;
const sort = svs.components.racing.resultUtils.sorting.sort;
const useNavigationState = svs.racing.navigation.useNavigationState;
const _svs$components$racin3 = svs.components.racing.resultUtils.myGamingUtil,
  gameTypeHasSmygen = _svs$components$racin3.gameTypeHasSmygen,
  getIsLegacyTopp5 = _svs$components$racin3.getIsLegacyTopp5;

const bestPossibleRowCalc = (result, row, resultIndexExamined) => {
  const bestRow = row;
  const bestPossibleRow = [...result];
  for (let i = 0; i < resultIndexExamined.length; i++) {
    const examinedIndex = resultIndexExamined[i];
    const examinedValue = result[examinedIndex];
    const examinedValueInBestRowIndex = bestRow.indexOf(examinedValue);
    if (examinedValueInBestRowIndex > -1) {
      if (examinedValueInBestRowIndex === examinedIndex) {
      } else {
        const bestRowValue = bestRow[examinedValueInBestRowIndex];
        const potentialSwapIndex = bestPossibleRow.indexOf(bestRowValue);
        if (potentialSwapIndex > -1) {
          bestPossibleRow[potentialSwapIndex] = bestPossibleRow[examinedValueInBestRowIndex];
        }
        bestPossibleRow[examinedValueInBestRowIndex] = bestRowValue;
      }
    } else {
      const indexBestPossibleRowMatch = bestPossibleRow.indexOf(examinedValue);
      let uselessValueInBestRowIndex = -1;
      for (let j = bestRow.length - 1; j >= 0; j--) {
        if (result.indexOf(bestRow[j]) < 0 && bestPossibleRow.indexOf(bestRow[j]) < 0) {
          uselessValueInBestRowIndex = j;
          break;
        }
      }
      const prevValue = bestPossibleRow[uselessValueInBestRowIndex];
      bestPossibleRow[uselessValueInBestRowIndex] = bestRow[uselessValueInBestRowIndex];
      if (uselessValueInBestRowIndex !== indexBestPossibleRowMatch) {
        bestPossibleRow[indexBestPossibleRowMatch] = prevValue;
      }
    }
  }
  return bestPossibleRow;
};
const useResultRow = (wager, race, selectedView, isSmygen) => {
  const wagerGameType = useMemo(() => {
    if (wager) {
      return myGamingUtil.getWagerGameType(wager);
    }
    return undefined;
  }, [wager]);
  const isLegacyTopp5 = useMemo(() => getIsLegacyTopp5(wager, race), [wager, race]);
  const result = useMemo(() => {
    if (wager && wager.completed && race && race.participants) {
      return myGamingUtil.getResult(race.participants, wagerGameType);
    }
    return undefined;
  }, [wager, race, wagerGameType]);
  const resultRows = useMemo(() => result ? buildUniqueRankRows(result, result.length) : undefined, [result]);
  const cancelledParticipants = useMemo(() => {
    if (race && race.participants) {
      return getCancelledParticipants(race.participants);
    }
    return undefined;
  }, [race]);
  const navState = useNavigationState();
  const _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    rowObjects = _useState2[0],
    setRowObjects = _useState2[1];
  const _useState3 = useState(undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    initialRowObjects = _useState4[0],
    setIntialRowObjects = _useState4[1];
  const _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    resultIndexExamined = _useState6[0],
    setResultIndexExamined = _useState6[1];
  const _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    wagerRowExamined = _useState8[0],
    setWagerRowExamined = _useState8[1];
  useEffect(() => {
    if (wager && cancelledParticipants) {
      const resultingRows = wagerToRows(wager.wager, resultRows, cancelledParticipants, navState.wagerExamined, selectedView, isSmygen, isLegacyTopp5);
      setRowObjects(resultingRows);
      setIntialRowObjects(resultingRows);
    }
  }, [wager, resultRows, cancelledParticipants, selectedView, isSmygen]);
  const resultRowObject = useMemo(() => {
    if (result && rowObjects && wager) {
      return myGamingUtil.getResultRowObject(result, rowObjects, wagerGameType, isLegacyTopp5);
    }
  }, [result, rowObjects, wager, wagerGameType]);
  const setWagerRowExaminedOnce = index => {
    var _resultRowObject$row;
    const resultingRow = resultRowObject === null || resultRowObject === void 0 || (_resultRowObject$row = resultRowObject.row) === null || _resultRowObject$row === void 0 ? void 0 : _resultRowObject$row.flat();
    if (resultIndexExamined.indexOf(index) < 0) {
      setResultIndexExamined([...resultIndexExamined, index]);
    }
    if (wagerRowExamined.indexOf(resultingRow[index]) < 0 && resultingRow[index] < 100) {
      setWagerRowExamined([...wagerRowExamined, ...resultRowObject.row[index]]);
    }
    setRowValues([...resultIndexExamined, index]);
  };
  const bestPossibleWinDiv = useMemo(() => {
    if (!rowObjects || !result || !resultIndexExamined || !gameTypeHasSmygen(myGamingUtil.getWagerGameType(wager))) {
      return undefined;
    }
    const selectedResultRow = resultRows[rowObjects[0].resultRowIndex];
    if (selectedResultRow === undefined || (selectedResultRow === null || selectedResultRow === void 0 ? void 0 : selectedResultRow.length) < 1) {
      return undefined;
    }
    const bestPossibleRow = bestPossibleRowCalc(selectedResultRow, rowObjects[0].row, resultIndexExamined);
    const partialRowObj = getRowValues(selectedResultRow, bestPossibleRow);
    const winDiv = getRowWindiv(partialRowObj, gameTypeWindivs[wagerGameType].conditions(isLegacyTopp5));
    return {
      winDiv
    };
  }, [rowObjects, result, resultIndexExamined, resultRows, wager, wagerGameType]);
  const setRowValues = resIndexExamined => {
    if (resIndexExamined.length === 5) {
      var _gameTypeWindivs$game;
      setRowObjects(initialRowObjects.sort(sort((_gameTypeWindivs$game = gameTypeWindivs[gameTypes.TOPP5]) === null || _gameTypeWindivs$game === void 0 ? void 0 : _gameTypeWindivs$game.sorting)));
      return false;
    }
    if (rowObjects && rowObjects.length && resultRows) {
      var _gameTypeWindivs$game2;
      let potentialRowObjects = rowObjects.map(row => {
        if (row.resultRowIndex >= 0) {
          const selectedResultRow = resultRows[row.resultRowIndex];
          const currentPossibleResultRow = selectedResultRow.map((srRow, i) => {
            if (resIndexExamined.indexOf(i) > -1) {
              return srRow;
            }
            return i + resultPlaceholders.FAKE_HORSE_NUM;
          });
          const bestPossibleRow = bestPossibleRowCalc(resultRows[row.resultRowIndex], row.row, resIndexExamined);
          const partialRowObj = getRowValues(currentPossibleResultRow, row.row);
          const _getRowValues = getRowValues(selectedResultRow, bestPossibleRow),
            bestPossibleRowValues = _getRowValues.rowValues,
            bestPossibleResultToRowIndices = _getRowValues.resultToRowIndices;
          const bestPartialRowObj = _objectSpread(_objectSpread({}, partialRowObj), {}, {
            rowValues: bestPossibleRowValues,
            resultToRowIndices: bestPossibleResultToRowIndices,
            resultRowUsed: resultRows[row.resultRowIndex]
          });
          const winDiv = getRowWindiv(partialRowObj, gameTypeWindivs[wagerGameType].conditions(isLegacyTopp5));
          const newPartialRowObj = _objectSpread(_objectSpread(_objectSpread({}, row), bestPartialRowObj), {}, {
            windiv: winDiv
          });
          return _objectSpread(_objectSpread({}, newPartialRowObj), {}, {
            rowValues: getRowValuesWithIrrelevant(newPartialRowObj)
          });
        }
        return row;
      });
      potentialRowObjects = potentialRowObjects.map(potentialRowObject => _objectSpread(_objectSpread({}, potentialRowObject), {}, {
        numTotalCorrectIrrelevant: getNumTotalCorrectIrrelevant(potentialRowObject)
      }));
      setRowObjects(potentialRowObjects.sort(sort((_gameTypeWindivs$game2 = gameTypeWindivs[gameTypes.TOPP5]) === null || _gameTypeWindivs$game2 === void 0 ? void 0 : _gameTypeWindivs$game2.sorting)));
    }
  };
  return {
    resultRowObject,
    rowObjects,
    bestPossibleWinDiv,
    wagerRowIndexExamined: resultIndexExamined,
    setWagerRowIndexExamined: setResultIndexExamined,
    setWagerRowExaminedOnce,
    wagerRowExamined,
    setWagerRowExamined
  };
};
setGlobal('svs.components.racing.resultUtils.bestPossibleRowCalc', bestPossibleRowCalc);
setGlobal('svs.components.racing.resultUtils.useResultRow', useResultRow);

 })(window);